import List from '../pages/social/List.vue'
import Router from "vue-router";
import store1 from "../store/index.js";

import Landing from "../pages/common-apps/Landing.vue";

const baseRoutes = [
  {
    path: '/',
    redirect: { name: 'Landing' }
  },
  {
    path: '/landing',
    name: 'Landing',
    component: Landing,
    meta: { bodyClass: 'landing-page' }
  }
] // to comment Landing route when using on dev mode


const socialRoutes = [
  {
    path: '/list',
    name: 'Social List',
    component: List,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/contacts',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "contact" */ "../pages/social/Contact.vue"),
    // component: Contact,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/birthdays',
    name: 'Birthday',
    component: () => import(/* webpackChunkName: "birthday" */ "../pages/social/Birthday.vue"),
    // component: Birthday,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
]

const routes = baseRoutes.concat(socialRoutes)


const routerSocial = new Router({
  routes,
  base: 'soc',
  mode: 'history'
})

routerSocial.beforeEach((to, from, next) => {
  // vueBodyClass.guard(to, next)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store1.getters['account/isAuthenticated']) {
      next()
      return
    }
    next('/landing')
  } else {
    next()
  }
})


export default routerSocial